// Quotation InternalReview Stage  Btn related codes goes here

// NPM Imports
import React, { Component, Fragment } from "react";

// Components Imports
// import { Button } from "../../../commonComponents";
import ExportDocumentBtn from "../../QuotationTopbar/QuotationTopbarBtns/ExportDocumentBtn";
import QuotationBottomStages from "../../QuotationTopbar/QuotationBottomBar/QuotationBottomStages";

// Declarations

class QuotationInternalReviewBtns extends Component {
  state = {};

  render() {
    return (
      <Fragment>
        {/* <Button
          className="approve-document"
          onClick={() => this.props.togglePopUp("Approve", true)}
          id={"Approve".replace(/ +/g, "-").toLowerCase()}
          data-test="quotationTopbar-upgrade-stage-btn">
          Approve
        </Button>
        <Button
          className="reject-document"
          onClick={() => this.props.togglePopUp("Reject", true)}
          id={"Reject".replace(/ +/g, "-").toLowerCase()}
          data-test="quotationTopbar-upgrade-stage-btn">
          Reject
        </Button> */}
        {(this.props.docStage === "SENT" ||
          this.props.docStage === "SENT_FOR_FILLING") && (
          <div className="other-approvers-buttons">
            <QuotationBottomStages {...this.props} />
          </div>
        )}
        <ExportDocumentBtn docStatus={this.props.docStatus} />
      </Fragment>
    );
  }
}

export default QuotationInternalReviewBtns;



// WEBPACK FOOTER //
// ./src/components/QuotationTopBarV2/QuotationTopBarBtns/QuotationInternalReviewBtns.js